<ion-menu contentId="main-content" type="overlay">
  <ion-content class="app-page">
    <div class="menu-panel">
      <div>
        <p class="eyebrow">Automation OS</p>
        <h2 class="section-title">WhatsApp Growth Engine</h2>
        <p class="subtle-copy">
          Manage onboarding, coexistence, templates, and campaigns from one product surface.
        </p>
      </div>

      <ion-list lines="none">
        <ion-menu-toggle auto-hide="true" *ngFor="let item of navigation">
          <ion-item
            button
            detail="false"
            [routerLink]="item.route"
            routerDirection="root"
            class="nav-item"
          >
            <ion-icon [name]="item.icon" slot="start"></ion-icon>
            <ion-label>{{ item.label }}</ion-label>
          </ion-item>
        </ion-menu-toggle>
      </ion-list>

      <ion-button expand="block" fill="solid" color="primary" (click)="logout()">
        Logout
      </ion-button>
    </div>
  </ion-content>
</ion-menu>

<div class="ion-page shell" id="main-content">
  <ion-header translucent="true">
    <ion-toolbar class="app-toolbar">
      <ion-buttons slot="start">
        <ion-menu-button></ion-menu-button>
      </ion-buttons>
      <ion-title>PingoraX</ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-router-outlet></ion-router-outlet>
</div>
